import {createGlobalContext} from '@acng/frontend-relativity';

export const ctxUnreadDialogs = createGlobalContext(0);
